import { render } from "./CommContact.vue?vue&type=template&id=6a0df414&scoped=true"
import script from "./CommContact.vue?vue&type=script&lang=js"
export * from "./CommContact.vue?vue&type=script&lang=js"

import "./CommContact.vue?vue&type=style&index=0&id=6a0df414&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0df414"]])

export default __exports__